module.exports = __webpack_public_path__ + "static/img/noun_pause_3535549.3fabac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/noun_pause_3535549.png
// module id = 8p66
// module chunks = 1